import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ServiciosExternosComponent } from './servicio-externos/servicios-externos.component';
import { ConfiguracionServiciosComponent } from './config-servicios/config-servicios.component';
import { adminGuard } from 'src/app/guards/admin.guard';



const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'servicios-externos',
        component: ServiciosExternosComponent,
        data: {
          title: "Servicios Externos",
          breadcrumb: "Servicios Externos"
        },
        canActivate: [adminGuard]
      },
      {
        path: 'configuracion/servicios-externos/:id',
        component: ConfiguracionServiciosComponent,
        data: {
          title: "Servicios Externos",
          breadcrumb: "Servicios Externos"
        },
        canActivate: [adminGuard]
      },
      {
        path: 'configuracion/servicios-externos/:id/:id_bucket',
        component: ConfiguracionServiciosComponent,
        data: {
          title: "Servicios Externos",
          breadcrumb: "Servicios Externos"
        },
        canActivate: [adminGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IntegracionesRoutingModule { }